var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_vm._v("\n  Profile\n  "),_c('button',{on:{"click":_vm.showUrbanModal}},[_vm._v("\n    Request 열기\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }